<template>
  <q-datetime
    v-model="localValue"
    :clearable="true"
    :align="column.align"
    :hide-underline="true"
    placeholder="All"
    @input="applyFilter"
    @clear="applyFilter"
  ></q-datetime>
</template>
<script>
import { extend } from 'quasar'
import { normalizeDate } from '../../utils/dateHelpers'

export default {
  name: 'DateFilter',
  data () {
    return {
      localValue: undefined
    }
  },
  props: {
    column: {
      type: Object
    },
    resource: {
      type: String,
      default () {
        return this.$route.meta.resource
      }
    },
    value: {}
  },
  computed: {
    labelField () {
      return this.column.relation
        ? this.column.relation.label || 'name'
        : this.column.field
    },
    computedProps () {
      const props = this.column.component ? this.column.component.props : {}
      return extend(true, {}, props, {
        type: props.type === 'datetime' ? 'date' : props.type
      })
    }
  },
  methods: {
    applyFilter () {
      /*
      let dt = normalizeDate(this.localValue)
      const dt1 = dt.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      const dt2 = dt.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      */
      if (this.column.relation) {
        this.$emit('apply', {
          [this.labelField]: normalizeDate(this.localValue, 'mysql')
        })
      } else {
        this.$emit('apply', normalizeDate(this.localValue, 'mysql'))
      }
    },
    setValue (v) {
      if (typeof v === 'object' && !Array.isArray(v) && v) {
        if (this.labelField && this.column.relation && v[this.labelField]) {
          this.localValue = v[this.labelField] || null
        }
      } else {
        this.localValue = v || null
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) {
          this.setValue(normalizeDate(v, 'js'))
        } else {
          this.localValue = null
        }
      },
      immediate: true
    }
  }
}
</script>
